import { render, staticRenderFns } from "./Fb.vue?vue&type=template&id=63492112&scoped=true&"
import script from "./Fb.vue?vue&type=script&lang=js&"
export * from "./Fb.vue?vue&type=script&lang=js&"
import style0 from "./Fb.vue?vue&type=style&index=0&id=63492112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63492112",
  null
  
)

export default component.exports